import { type DefaultTheme, type FlattenInterpolation, type ThemeProps, css } from 'styled-components';

export const getDisabledDatePickerStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  border-color: ${({ theme }) => theme.color.grey.grey4};
  background-color: ${({ theme }) => theme.color.grey.grey4};

  .ant-picker-suffix {
    color: ${({ theme }) => theme.color.grey.grey6};
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.grey.grey4};

    .ant-picker-suffix {
      color: ${({ theme }) => theme.color.grey.grey6};
    }
  }
`;
